module.exports = __webpack_public_path__ + "static/img/DDC_BestofDayton_19_937x360.a7c8485.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DDC_BestofDayton_19_937x360.jpg
// module id = 273
// module chunks = 1